import {ObvioEvent} from 'Event'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useQuery} from 'react-query'

export type ObieStep = {
  id: string
  name: string
}

export function useObieSteps(params: {
  client: Client
  event: ObvioEvent
  obieMilestoneId: string
}) {
  const {client, event, obieMilestoneId} = params

  return useQuery<ObieStep[], {message: string; status?: number}>({
    queryKey: [
      'events',
      event.id,
      'integrations',
      'obie',
      'steps',
      obieMilestoneId,
    ],
    queryFn: () =>
      client.get<ObieStep[]>(
        api(
          `/events/${event.id}/integrations/obie/steps?obie_milestone_id=${obieMilestoneId}`,
        ),
      ),
    retry: (failureCount, error) => error.status !== 404 && failureCount < 3,
  })
}
